import { SYS_CURRENCY } from './const';

export const columnSum = (array, columnName) => {
  if (!(array && columnName)) {
    return 0;
  }

  let sum = array.reduce((prev, cur) => {
    return prev + cur[columnName];
  }, 0);

  return sum;
};

export const absBalance = (balanceAmount = 0) => {
  return balanceAmount >= 0 ? balanceAmount : `(${Math.abs(balanceAmount)})`;
};

export const getTV = (data = [], settingsObj = {}) => {
  const { textField = 'text', valueField = 'value', deselectText = '-- Not Selected --', isDeselect = true } = settingsObj;

  let deselectITtem = isDeselect === true ? [{ text: deselectText, value: "" }] : [];
  const dataTV = data.map(r => ({ text: r[textField], value: r[valueField] }));

  return [...deselectITtem, ...dataTV];
};

export const removeEmptyProps = (obj, fieldsTobeChecked = []) => {
  for (var propName in obj) {
    if (fieldsTobeChecked.length > 0 && !fieldsTobeChecked.includes(propName)) {
      continue;
    }

    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
      delete obj[propName];
    }
  }
  return obj
}

export const valueToText = (TVarray = [], value = "") => {
  const item = TVarray.find(r => r.value == value);
  return item.text ? item.text : ""
}

export const moneyAmount = (amount = 0) => {
  return `${SYS_CURRENCY} ${amount}`;
}
